import * as React from "react";
import { isEmpty } from "lodash";

interface TitleDeedInfoProps {
  path: string;
  type_loan: string;
  appid: string;
  borrowername: string;
  bank_name: string;
  login_time: string;
  loan_amount: string;
  contact_number: string;
  coApplicant: string;
  deedinfo: any[];
}

const TitleDeedInfo: React.FC<TitleDeedInfoProps> = ({
  path,
  type_loan,
  appid,
  borrowername,
  bank_name,
  login_time,
  loan_amount,
  contact_number,
  coApplicant,
  deedinfo,
}) => {
  return (
    <div
      className="card latest-update-card"
      style={{ height: path === "index" ? "84vh" : (path == 'querymaildetails' ? "64vh" : "68vh") }}
    >
      <div className="card-header">
        <h5>Title Deed Info</h5>
      </div>
      <div className="card-body" style={{ overflowY: "scroll" }}>
        <div
          className="m-2"
          style={{ borderBottom: "2px solid #bbb4b4", paddingBottom: "2%" }}
        >
          <p style={{ fontFamily: "unset" }}>Type Of Loan - {type_loan}</p>
          <p style={{ fontFamily: "unset" }}>App Id - {appid}</p>
          <p style={{ fontFamily: "unset" }}>Bank Name - {bank_name}</p>
          <p style={{ fontFamily: "unset" }}>Borrower Name - {borrowername}</p>
          {!isEmpty(coApplicant) && <p style={{ fontFamily: "unset" }}>Co-Applicant - {coApplicant}</p>}
          <p style={{ fontFamily: "unset" }}>Loan Amount - {loan_amount}</p>
          <p style={{ fontFamily: "unset" }}>LH Branch Contact Number - {contact_number}</p>
          <p style={{ fontFamily: "unset" }}>Login Date - {login_time}</p>
        </div>

        {deedinfo && deedinfo.length > 0 ? (
          deedinfo.map((info: any, index: number) => (
            <div className="mt-3 hint-title-deed" key={index}>
              <h6>
                <b>Title Deed Info - {index + 1}</b>
              </h6>
              <p>
                <span>*</span> Property Owner Name - {info.name || ""}
              </p>
              <p>
                <span>*</span> Document No - {info.doc_no || ""}
              </p>
              <p>
                <span>*</span> Document Type - {info.doc_type || ""}
              </p>
              <p>
                <span>*</span> Schedule / Item No / Plot No -{" "}
                {info.schedule || ""}
              </p>

              <div className="mt-2">
                {info?.survey_no &&
                  info.survey_no.map((survey: any, surveyindex: number) => (
                    <div key={surveyindex}>
                      <table className="table-style">
                        {surveyindex === 0 && (
                          <tr className="row-style">
                            <th className="head-style">S.No</th>
                            <th className="head-style">S.No / T.S.No</th>
                            <th className="head-style">Extent / Unit</th>
                          </tr>
                        )}
                        <tr className="row-style">
                          <td className="data-style" style={{ width: "65px" }}>
                            {surveyindex + 1}
                          </td>
                          <td className="data-style" style={{ width: "181px" }}>
                            {survey.survey_no || ""}
                          </td>
                          <td className="data-style">
                            {survey.extent || ""} {survey.unit || ""}
                          </td>
                        </tr>
                      </table>
                    </div>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <div
            className="mt-5"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p>
              <b>Data not found</b>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TitleDeedInfo;
